<template>
  <div class="page">
     <div class="img-list">
        <img :src="item" alt="" v-for="(item,index) in imgs" :key="index">
     </div>
    <div class="page-title">检测记录</div>

    <div class="collapse-list">
      <div class="collapse-item" v-for="(item, idx) in list" :key="idx">
        <div class="item-head" @click="toggle(idx)">
          <!-- 检测日期： -->
          <span>{{ item.test_date }}</span>
          <van-icon :name="openIdx === idx ? 'arrow-up' : 'arrow'" color="#8c92a3" />
        </div>

        <div class="item-body" v-show="openIdx === idx">
          <div class="scroll-content">
            <div :ref="el => { if (el) $refs[`pdfWrapper_${idx}`] = el }" class="pdf-wrapper"></div>
            <div class="zoom-hint">点击图片可放大查看</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../common/http.js";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      openIdx: null,
      pdfjsLoaded: false,
      list: [ ],
      imgs:[
        'https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/other/20264/69e86f21ac5073a20c23707f.png',
        'https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/other/20264/69e86f21ac5073a20c237081.png',
        'https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/other/20264/69e86f21ac5073a20c237080.png',
        'https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/other/20264/69e86f21ac5073a20c237082.png',
        'https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/other/20264/69e86f21ac5073a20c237083.png',
        'https://caredaily-cloud.oss-cn-hangzhou.aliyuncs.com/other/20264/69e86f21ac5073a20c237084.png'
      ]
    }
  },
  created() {
    this.getPageData()
  },
  methods: {
   async getPageData(){
        let currentProductId=sessionStorage.getItem('currentProductId')
        try{
        let res = await http.get(`/goods/public/inspection_report/${currentProductId}`)
        this.list=res.data || []
        }catch (error) {
          console.log(error,'error=');
        }
      
        
    },
    async toggle(idx) {
      if (this.openIdx === idx) {
        this.openIdx = null
        return
      }
      this.openIdx = idx
      await this.$nextTick()
      await this.$nextTick()

      const currentItem = this.list[idx]
      this.renderAllPdfPages(idx, currentItem)
    },

    async renderAllPdfPages(idx, item) {
      const wrapper = this.$refs[`pdfWrapper_${idx}`]
      if (!wrapper || !item.content || !item.content.url) return;

      const pdfUrl = item.content.url

      if (!this.pdfjsLoaded) {
        await this.loadScript('https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.min.js')
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js'
        this.pdfjsLoaded = true
      }

      wrapper.innerHTML = ''
      const pdfjs = window.pdfjsLib
      const pdf = await pdfjs.getDocument(pdfUrl).promise

      const containerWidth = document.documentElement.clientWidth - 40
      // 固定高清倍率，不模糊也不会太大
      const FIXED_SCALE = 4

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        const page = await pdf.getPage(pageNum)
        const viewport = page.getViewport({ scale: 1 })
        const scale = containerWidth / viewport.width

        const scaledViewport = page.getViewport({
          scale: scale * FIXED_SCALE
        })

        const canvas = document.createElement('canvas')
        canvas.width = scaledViewport.width
        canvas.height = scaledViewport.height

        // 关键：CSS 强制宽度100%，高清但不撑大
        canvas.style.width = '100%'
        canvas.style.height = 'auto'
        canvas.style.display = 'block'
        canvas.style.marginBottom = '12px'
        canvas.style.cursor = 'zoom-in'

        const ctx = canvas.getContext('2d')
        // 铺白底，转 JPEG 预览图时透明区域不会变黑
        ctx.fillStyle = '#fff'
        ctx.fillRect(0, 0, canvas.width, canvas.height)
        wrapper.appendChild(canvas)

        // 点击该页放大全屏预览
        canvas.addEventListener('click', () => {
          this.previewPdfPages(idx, pageNum - 1)
        })

        await page.render({
          canvasContext: ctx,
          viewport: scaledViewport
        }).promise
      }
    },

    previewPdfPages(idx, startIndex) {
      const wrapper = this.$refs[`pdfWrapper_${idx}`]
      if (!wrapper) return
      const images = Array.from(wrapper.querySelectorAll('canvas'))
        .map(c => c.toDataURL('image/jpeg', 0.9))
      ImagePreview({
        images,
        startPosition: startIndex,
        closeable: true
      })
    },

    loadScript(src) {
      return new Promise((resolve) => {
        const s = document.createElement('script')
        s.src = src
        s.onload = resolve
        document.body.appendChild(s)
      })
    }
  }
}
</script>

<style scoped>
.page {
  padding: 24px 16px;
  background: #f7f8fc;
  min-height: 100vh;
}
.img-list{
  display: flex;
  flex-wrap: wrap;
  margin: 0 -4px; /* 抵消内边距，让排版更整齐 */
  margin-bottom: 10px;
}
.img-list img {
  width: 33.333%;
  padding: 4px;
  box-sizing: border-box;
  object-fit: cover; /* 图片不变形 */
}
.page-title {
  position: relative;
  font-size: 20px;
  font-weight: 700;
  padding-left: 12px;
  margin-bottom: 20px;
}
.page-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px; height: 16px;
  background: #2E5CFA;
}
.collapse-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.collapse-item {
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
}
.item-head {
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item-body {
  border-top: 1px solid #f2f3f8;
}

.scroll-content {
  height: 460px;
  overflow-y: auto;
  padding: 10px;
  -webkit-overflow-scrolling: touch;
}

.pdf-wrapper {
  width: 100%;
}

.zoom-hint {
  text-align: center;
  font-size: 12px;
  color: #8c92a3;
  padding-bottom: 6px;
}
</style>